const config = {
  apiURL: process.env.VUE_APP_API_BASE_URL,
};

export default config;
